/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Project_Instructions_Chip2_LabelInputs */



/**
* | output |
* | --- |
* | "Do changes affect existing chats?" |
*
* @param {Uno_Edu_Project_Instructions_Chip2_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_project_instructions_chip2_label = /** @type {((inputs?: Uno_Edu_Project_Instructions_Chip2_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Project_Instructions_Chip2_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wirken sich Änderungen auf bestehende Chats aus?")
	return /** @type {LocalizedString} */ ("Do changes affect existing chats?")
});